<template>
  <div class="login-wrapper">

    <!-- Panneau gauche -->
    <div class="left-panel">
      <div class="left-deco left-deco--top"></div>
      <div class="left-deco left-deco--bottom"></div>

      <div class="left-content">
        <div>
          <div class="brand-icon">
            <v-icon size="36" color="white">mdi-calendar-check</v-icon>
          </div>
          <div class="brand-name">ACCEN</div>
          <div class="brand-sub">Informatique</div>
          <div class="brand-divider"></div>
          <p class="brand-pitch">
            Gérez vos congés simplement et efficacement.<br>
            Suivi en temps réel, validation rapide.
          </p>
          <div class="features">
            <div class="feature-item">
              <v-icon size="18" color="white" style="opacity:.85">mdi-check-circle-outline</v-icon>
              <span>Demandes de congé en ligne</span>
            </div>
            <div class="feature-item">
              <v-icon size="18" color="white" style="opacity:.85">mdi-check-circle-outline</v-icon>
              <span>Validation hiérarchique</span>
            </div>
            <div class="feature-item">
              <v-icon size="18" color="white" style="opacity:.85">mdi-check-circle-outline</v-icon>
              <span>Planning collaboratif</span>
            </div>
          </div>
        </div>
        <div class="brand-footer">© 2026 ACCEN Informatique</div>
      </div>
    </div>

    <!-- Panneau droit -->
    <div class="right-panel">
      <div v-if="isLoading" class="loading-state">
        <v-progress-circular size="64" width="5" indeterminate color="#3f51b5" />
      </div>

      <div v-else class="form-wrapper">
        <div class="form-title">Bienvenue</div>
        <div class="form-subtitle">Connectez-vous à votre espace</div>

        <div class="form-card">
          <!-- Erreur -->
          <v-alert
            v-if="invalidUser"
            type="error"
            variant="tonal"
            density="compact"
            class="mb-4"
            rounded="lg"
          >
            Identifiant ou mot de passe incorrect
          </v-alert>

          <!-- Identifiant -->
          <div class="field-label">Identifiant</div>
          <v-text-field
            v-model="user.email"
            placeholder="Votre identifiant ou email"
            variant="outlined"
            density="comfortable"
            hide-details
            rounded="lg"
            class="mb-4"
            @keyup.enter="login"
          >
            <template #prepend-inner>
              <v-icon color="#9e9e9e" size="20">mdi-account-outline</v-icon>
            </template>
          </v-text-field>

          <!-- Mot de passe -->
          <div class="field-label">Mot de passe</div>
          <v-text-field
            v-model="user.password"
            placeholder="Votre mot de passe"
            :type="showPassword ? 'text' : 'password'"
            variant="outlined"
            density="comfortable"
            hide-details
            rounded="lg"
            class="mb-6"
            @keyup.enter="login"
          >
            <template #prepend-inner>
              <v-icon color="#9e9e9e" size="20">mdi-lock-outline</v-icon>
            </template>
            <template #append-inner>
              <v-icon
                color="#9e9e9e"
                size="20"
                style="cursor:pointer"
                @click="showPassword = !showPassword"
              >
                {{ showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}
              </v-icon>
            </template>
          </v-text-field>

          <!-- Bouton -->
          <v-btn
            block
            size="large"
            rounded="lg"
            class="login-btn"
            @click="login"
          >
            <v-icon start>mdi-login</v-icon>
            SE CONNECTER
          </v-btn>

          <div class="help-text">
            Problème de connexion ? Contactez votre administrateur.
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import engine from "@/core/index";

export default {
  data() {
    return {
      isLoading: true,
      invalidUser: false,
      showPassword: false,
      user: { email: "", password: "" },
    };
  },
  mounted() {
    this.isUserConnected();
  },
  methods: {
    updateUser() {
      let that = this;
      let token = localStorage.getItem("userToken");
      engine.get_user_by_token(token, function (data) {
        if (data.code == 0) {
          let user = data.data.data.data[0].fieldData;
          delete user.user_id;
          delete user.user_password;
          that.$store.state.user = user;
        } else {
          that.$router.push("/login");
        }
        that.isLoading = false;
      });
    },
    isUserConnected() {
      let that = this;
      let token = localStorage.getItem("userToken");
      engine.get_user_by_token(token, function (data) {
        if (data.code == 0) {
          that.goToCalendarPage();
        } else {
          localStorage.setItem("userToken", undefined);
          that.isLoading = false;
        }
      });
    },
    login() {
      let that = this;
      this.invalidUser = false;
      if (this.user.email.length !== 0 && this.user.password.length !== 0)
        engine.user_login(this.user.email, this.user.password, function (data) {
          that.$store.replaceState({});
          if (data.code == 0) {
            localStorage.setItem("userToken", data.data.id);
            that.updateUser();
            that.goToCalendarPage();
          } else {
            that.invalidUser = true;
          }
        });
      else that.invalidUser = true;
    },
    goToCalendarPage() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.login-wrapper {
  display: flex;
  min-height: 100vh;
}

/* ── PANNEAU GAUCHE ── */
.left-panel {
  position: relative;
  width: 40%;
  background: linear-gradient(160deg, #3949ab 0%, #283593 100%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.left-deco {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
}

.left-deco--top {
  width: 340px;
  height: 340px;
  top: -80px;
  right: -100px;
}

.left-deco--bottom {
  width: 420px;
  height: 420px;
  bottom: -140px;
  left: -120px;
}

.left-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 52px 48px;
}

.brand-icon {
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.brand-name {
  font-size: 38px;
  font-weight: 800;
  color: white;
  letter-spacing: 2px;
  line-height: 1;
}

.brand-sub {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 4px;
  font-weight: 400;
}

.brand-divider {
  width: 48px;
  height: 2px;
  background: rgba(255, 255, 255, 0.4);
  margin: 24px 0;
}

.brand-pitch {
  color: rgba(255, 255, 255, 0.85);
  font-size: 15px;
  line-height: 1.7;
  margin: 0 0 28px 0;
}

.features {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
}

.brand-footer {
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
}

/* ── PANNEAU DROIT ── */
.right-panel {
  flex: 1;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 32px;
}

.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-wrapper {
  width: 100%;
  max-width: 420px;
}

.form-title {
  font-size: 30px;
  font-weight: 800;
  color: #1a1a2e;
  text-align: center;
  margin-bottom: 6px;
}

.form-subtitle {
  font-size: 14px;
  color: #9e9e9e;
  text-align: center;
  margin-bottom: 32px;
}

.form-card {
  background: white;
  border-radius: 20px;
  padding: 36px 32px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07);
}

.field-label {
  font-size: 13px;
  font-weight: 600;
  color: #424242;
  margin-bottom: 6px;
}

.login-btn {
  background: #283593 !important;
  color: white !important;
  font-weight: 700;
  letter-spacing: 1.5px;
  font-size: 14px;
}

.help-text {
  text-align: center;
  font-size: 12px;
  color: #9e9e9e;
  margin-top: 16px;
}

@media (max-width: 768px) {
  .login-wrapper {
    flex-direction: column;
  }

  .left-panel {
    width: 100%;
    padding: 40px 24px;
    min-height: auto;
  }

  .left-content {
    padding: 0;
  }

  .brand-footer {
    display: none;
  }
}
</style>
